(function(){
	if(window.__bmProductDetailAccordionInit) return;
	window.__bmProductDetailAccordionInit = true;

	var DUR = 240;

	function bindAccordion(details){
		if(details.__bmAccordionBound) return;
		details.__bmAccordionBound = true;

		var summary = details.querySelector('summary');
		var body = details.querySelector('.bm_product_detail_all_body');

		if(!summary || !body) return;

		summary.addEventListener('click', function(e){
			e.preventDefault();

			if(details.__bmAccordionAnimating) return;
			details.__bmAccordionAnimating = true;

			if(!details.open){
				details.open = true;

				body.style.overflow = 'hidden';
				body.style.height = '0px';
				body.style.opacity = '0';

				var openHeight = body.scrollHeight;

				requestAnimationFrame(function(){
					body.style.transition = 'height ' + DUR + 'ms ease, opacity ' + DUR + 'ms ease';
					body.style.height = openHeight + 'px';
					body.style.opacity = '1';
				});

				window.setTimeout(function(){
					body.style.transition = '';
					body.style.height = '';
					body.style.overflow = '';
					body.style.opacity = '';
					details.__bmAccordionAnimating = false;
				}, DUR + 40);
			}else{
				var closeHeight = body.scrollHeight;

				body.style.overflow = 'hidden';
				body.style.height = closeHeight + 'px';
				body.style.opacity = '1';

				requestAnimationFrame(function(){
					body.style.transition = 'height ' + DUR + 'ms ease, opacity ' + DUR + 'ms ease';
					body.style.height = '0px';
					body.style.opacity = '0';
				});

				window.setTimeout(function(){
					details.open = false;
					body.style.transition = '';
					body.style.height = '';
					body.style.overflow = '';
					body.style.opacity = '';
					details.__bmAccordionAnimating = false;
				}, DUR + 40);
			}
		});
	}

	function init(){
		var detailsList = document.querySelectorAll('.bm_product_detail_root details.bm_product_detail_all');
		for(var i = 0; i < detailsList.length; i++){
			bindAccordion(detailsList[i]);
		}
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', init);
	}else{
		init();
	}
})();